"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRAuthPlugin = void 0;
const helpers_1 = require("../../../core/helpers");
/**
 *
 * @deprecated please use from web-ui-security instead
 * @link https://github.com/santander-group-ods/SOFTWEB-web-ui-security | web-ui-security
 *
 */
class XHRAuthPlugin {
    constructor(session) {
        this.name = this.constructor.name;
        this.session = session;
    }
    handleRequest(request) {
        const sessionData = this.session.getData();
        if (sessionData === null || sessionData === void 0 ? void 0 : sessionData.accessToken) {
            const { accessToken } = sessionData;
            request.headers = Object.assign(Object.assign({}, request.headers), { accessToken });
        }
        else {
            helpers_1.Log.warn('Session data is not valid, need accessToken');
        }
        return Promise.resolve(request);
    }
}
exports.XHRAuthPlugin = XHRAuthPlugin;
//# sourceMappingURL=xhrAuthPlugin.js.map